var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MMCard',{attrs:{"showTitle":false}},[_c('template',{slot:"content"},[_c('div',{staticClass:"tips"},[_c('i',{staticClass:"bi bi-volume-up",staticStyle:{"font-size":"1.2rem"}}),_c('span',[_vm._v(_vm._s(_vm.content))])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }